import { IOperationalCostsFilters } from 'features/OperationalCosts/types'
import { BusinessClientSuggestion, BusinessSiteSuggestion, VehicleTemplateSuggestion } from 'gql/generated/graphql'
import { getQueryString } from 'utils/route'
import { getStateByStateCode } from 'utils/states'

export const mapSearchToFiltersForm = (
  searchQueries: Record<string, string | undefined>,
  {
    businessClient,
    businessSite,
    vehicleTemplate
  }: {
    businessClient: BusinessClientSuggestion | null
    businessSite: BusinessSiteSuggestion | null
    vehicleTemplate: VehicleTemplateSuggestion | null
  }
): IOperationalCostsFilters => {
  const state = searchQueries.stateCode ? getStateByStateCode(searchQueries.stateCode) : null
  return {
    state: state || {
      code: '',
      name: ''
    },
    businessClient: businessClient || {
      id: searchQueries.businessClientId || '',
      name: ''
    },
    businessSite: businessSite || {
      id: searchQueries.businessSiteId || '',
      name: ''
    },
    vehicleTemplate: vehicleTemplate || null
  }
}

export const mapFiltersToSearchQueryString = (filters: IOperationalCostsFilters, pageNb = 1): string => {
  return getQueryString({
    page: pageNb,
    businessClientId: filters.businessClient?.id,
    businessSiteId: filters.businessSite?.id,
    stateCode: filters.state?.code,
    vehicleTemplateId: filters.vehicleTemplate?.id
  })
}
